import request from '@/utils/http'

const PREFIX = '/eventGroup'

const eventGroup = {
  list(projectId) {
    return request(
      `${PREFIX}/list/` + projectId,
      'get'
    )
  },
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },
  changeGroup(params) {
    return request(
      `${PREFIX}/batchGroup`,
      'post',
      params
    )
  },
  unGroupList(params) {
    return request(
      `${PREFIX}/unGroup`,
      'get',
      params
    )
  },
  groupList(params) {
    return request(
      `${PREFIX}/list/page`,
      'get',
      params
    )
  },
  editGroup(id, data) {
    return request(
      `${PREFIX}/` + id,
      'put',
      data
    )
  },
  delete(id) {
    return request(
      `${PREFIX}/` + id,
      'delete'
    )
  }
}

export default eventGroup
